export default __webpack_public_path__ + "static/pragicts-digital-outreach-verticals-buildings-68020bc2be39a66c63dc2383601a5bd9.jpg";